export default {
  title: "Recherche rapide CBAM",
  subtitle: {
    noReg: "Aucune inscription requise",
    free: "Gratuit",
    minutes: "1 minute",
  },
  steps: {
    country: "Pays",
    product: "Produit",
    volume: "Volume d'importation",
    result: "Résultat",
  },
  step1: {
    title:
      "Importez-vous de l'extérieur de l'UE vers l'UE, ou faites-vous du commerce à l'intérieur de l'UE?",
    outsideEU: "Importation de l'extérieur de l'UE",
    insideEU: "À l'intérieur de l'UE (exempté)",
  },
  step2: {
    title: "Principaux produits importés ? (Sélection multiple possible)",
    steel: "Acier",
    aluminum: "Aluminium",
    cement: "Ciment",
    fertilizer: "Engrais",
    electricity: "Électricité",
    hydrogen: "Hydrogène",
    other: "Autre",
  },
  step3: {
    title: "Volume d'importation estimé dans l'UE en 2026 ?",
    lt50t: "< 50 tonnes (exempté)",
    between50_500t: "50–500 tonnes",
    gt500t: "> 500 tonnes",
  },
  result: {
    lowRisk: "Faible risque",
    mediumRisk: "Risque moyen",
    highRisk: "Haut risque",
    insideEU:
      "Félicitations ! Le commerce intra-UE est exempté, aucune déclaration/paiement requis. Mais nous recommandons de surveiller les changements.",
    outsideEU:
      "Félicitations ! Volume annuel < 50 tonnes exempté ou produits non couverts, aucune déclaration/paiement requis. Mais nous recommandons de surveiller les changements.",
    highRiskDesc:
      "Obligation de déclarer + acheter des certificats (basés sur les émissions), erreur > 10% entraîne une amende de €1K–€10K.",
    mediumRiskDesc:
      "Déclaration trimestrielle requise, paiement possible à partir de 2026. Nous recommandons de générer un rapport au format PwC pour atténuer les risques.",
  },
  whyChoose: {
    title: "Pourquoi choisir TaxEcoBit ?",
    description:
      "TaxEcoBit vous aide à calculer avec une précision de 90 %+, rapport PDF/Excel conforme en 3 secondes.",
    features: {
      accurate: "Conformité précise : Erreur <10%, répond aux exigences CBAM",
      fast: "Rapport rapide : 3 secondes pour générer un PDF/Excel conforme",
      cost: "Avantage coût : €99/mois, bien inférieur aux concurrents €500+/mois",
      trial: "Essai gratuit pendant 14 jours, profitez de toutes les fonctionnalités premium",
    },
  },
  newRule:
    "Nouvelle réglementation en 2026 : Annuel < 50 tonnes exempté (sauf hydrogène/électricité), mais les rapports doivent toujours être précis pour éviter les amendes.",
  buttons: {
    prev: "Précédent",
    next: "Suivant",
    viewResult: "Voir le résultat",
    generateReport: "Générer le rapport complet (Inscription/essai gratuit)",
    restart: "Redémarrer",
  },
};
